<fgb-page-header [pageTitle]="'payment.page.title'" [backButtonLink]="'/'" [showQr]="sgb ? false : true"></fgb-page-header>

<div class="d-block d-lg-none container">
  <fgb-payment-nav></fgb-payment-nav>
</div>

<div class="container">
  <h5 class="transaction-title">{{ 'transaction.page.title' | translate }}</h5>
  <fgb-transaction-history
    [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
    [ecashView]="true"
  ></fgb-transaction-history>
</div>
